import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useDispatch, useSelector } from "react-redux";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
import {
  CreateAdminRequestAction,
  DeleteAdminRequestAction,
  GetAllAdminRequestAction,
  GetRemainingAdminRequestAction,
  UpdateAdminRequestAction,
} from "../../../../redux/actions/AdminRequestAction";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import dayjs from "dayjs";
import axios from "axios";
import fileDownload from "js-file-download";
import { useReactToPrint } from "react-to-print";
import FormPrintView from "../../../Utility/FormPrintView/FormPrintView";
import { buildAdminRequestPrintFields, filterByEmployeeName } from "../../../Utility/FormPrintView/formPrintHelpers";
const filter = createFilterOptions();
const Enter = ({
  userData,
  key,
  setKey,
  Datee,
  setDate,
  DateFrom,
  setDateFrom,
  DateTo,
  setDateTo,
  TimeFrom,
  setTimeFrom,
  TimeTo,
  setTimeTo,
  Request,
  setRequest,
  ApprovedById,
  setApprovedById,
  approvedByName,
  setApprovedByName,
  NumberOfHours,
  NumberOfDays,
  Months,
  time,
  settime,
  Day,
  setDay,
  showCircleType,
  setshowCircleType,
  showSefam,
  setshowSefam,
  duration,
  setDuration,
  showSefak,
  setshowSefak,
  selectedFile,
  setSelectedFile,
  NoteFile,
  setNoteFile,
  Note,
  setNote,
  FileeBase64,
  setBase64,
  EmployeesId,
  setEmployeesId,
  isEdit,
  setIsEdit,
  Eye,
  setEye,
  AdminrequestId,
  setAdminrequestId,
  setNumberOfDays,
  setNumberOfHours,
  NumberOfAvaDays,
  setNumberOfAvaDays,
  BorrowValue,
  setBorrowValue,
}) => {
  const [Search, setSearch] = useState("");
  const printRef = useRef();
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات الطلبات",
    "بيانات الطلبات",
  );
  const AllEmplyee = useSelector((state) => state.EmployeeR.GetEmployee);
  const All = useSelector((state) => state.AdminRequestR.GetAdminRequest);

  const PageSize = 7;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);

  const buildSearchQuery = (page = 1) => {
    const query = { pageNumber: page, pageSize: PageSize };
    if (Search.trim()) query.searchTerm = Search.trim();
    return query;
  };

  const filteredRequests = filterByEmployeeName(All?.data, Search);

  useEffect(() => {
    dispatch(GetAllEmployeeAction());
    dispatch(GetAllAdminRequestAction(buildSearchQuery()));
  }, []);

  const handleSearch = async () => {
    await dispatch(GetAllAdminRequestAction(buildSearchQuery()));
  };
  const GetRemainingAdminRequest = useSelector(
    (state) => state.AdminRequestR.GetRemainingAdminRequest,
  );

  useEffect(() => {
    if (Request != null && EmployeesId?.id) {
      // Dispatch to get remaining days when dependencies change
      dispatch(
        GetRemainingAdminRequestAction(
          `userId=${EmployeesId.id}&request=${Request}`,
        ),
      );

      // Then set the available days based on result
      if (GetRemainingAdminRequest !== 0 && GetRemainingAdminRequest !== -1) {
        setNumberOfAvaDays(GetRemainingAdminRequest);
      } else if (GetRemainingAdminRequest === -1) {
        setNumberOfAvaDays(0);
      }
    }
  }, [Request, EmployeesId?.id, GetRemainingAdminRequest]);

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(GetAllAdminRequestAction(buildSearchQuery(page)));
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAdminrequestId(itemid);
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAdminRequestAction(AdminrequestId));
    setLoading(false);
    setshowDelete(false);
    setIsPress(false);
  };

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "بيانات الطلب",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Datee === "" || EmployeesId === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("RequestType", Request);
    formData.append("Note", Note);
    formData.append("DateFrom", DateFrom);
    formData.append("DateTo", DateTo);
    formData.append("NumberOfDays", NumberOfDays);
    formData.append(
      "TimeFrom",
      TimeFrom !== "" ? dayjs(TimeFrom).format("hh:mm:ss") : "",
    );
    formData.append(
      "TimeTo",
      TimeTo !== "" ? dayjs(TimeTo).format("hh:mm:ss") : "",
    );
    formData.append("NumberOfHours", NumberOfHours);
    if (ApprovedById) {
      formData.append("ApprovedById", userData.id);
    }
    formData.append("EmployeeId", EmployeesId.id);
    formData.append("BorrowValue", BorrowValue);
    formData.append("File", selectedFile);
    formData.append("FileDescription", NoteFile);
    await dispatch(CreateAdminRequestAction(formData));
    setDate("");
    setDateFrom("");
    setDateTo("");
    setTimeFrom("");
    setTimeTo("");
    setRequest("");
    setNumberOfDays("");
    setNumberOfHours("");
    setNote("");
    setNoteFile("");
    setSelectedFile("");
    setBase64("");
    setEmployeesId("");
    setAdminrequestId("");
    setApprovedById(false);
    setApprovedByName("");
    setIsEdit(false);
    setEye(false);
    setBorrowValue("");
    setEmployeesId("");

    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Datee === "" || EmployeesId === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 14
    ) {
      notify("غير مسموح بأضافة اكثر من 1 من الاجازات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Id", AdminrequestId);
    formData.append("Date", Datee);
    formData.append("RequestType", Request);
    formData.append("Note", Note);
    formData.append("DateFrom", DateFrom);
    formData.append("DateTo", DateTo);
    formData.append("NumberOfDays", NumberOfDays);
    formData.append(
      "TimeFrom",
      TimeFrom !== "" ? dayjs(TimeFrom).format("hh:mm:ss") : "",
    );
    formData.append(
      "TimeTo",
      TimeTo !== "" ? dayjs(TimeTo).format("hh:mm:ss") : "",
    );
    formData.append("NumberOfHours", NumberOfHours);
    if (ApprovedById) {
      formData.append("ApprovedById", userData.id);
    }
    formData.append("EmployeeId", EmployeesId.id);
    formData.append("BorrowValue", BorrowValue);
    formData.append("NewFile", selectedFile);
    formData.append("FileDescription", NoteFile);

    await dispatch(UpdateAdminRequestAction(formData));
    setDate("");
    setDateFrom("");
    setDateTo("");
    setTimeFrom("");
    setTimeTo("");
    setRequest("");
    setNumberOfDays("");
    setNumberOfHours("");
    setNote("");
    setNoteFile("");
    setSelectedFile("");
    setBase64("");
    setEmployeesId("");
    setAdminrequestId("");
    setBorrowValue("");
    setApprovedById(false);
    setApprovedByName("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };

  const Update = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setRequest(item.request);
    setNote(item.note);
    setDateFrom(item.dateFrom);
    setBorrowValue(item.borrowValue);
    setDateTo(item.dateTo);
    setTimeFrom(
      item.timeFrom !== null ? dayjs(`1970-01-01T${item.timeFrom}`) : "",
    );
    setTimeTo(item.timeTo != null ? dayjs(`1970-01-01T${item.timeTo}`) : "");
    setNoteFile(item.fileDescription);

    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setApprovedById(item.approvedById !== 0 ? true : false);
    setApprovedByName(item.approvedByName || "");

    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setRequest(item.request);
    setNote(item.note);
    setBorrowValue(item.borrowValue);

    setDateFrom(item.dateFrom);
    setDateTo(item.dateTo);
    setTimeFrom(dayjs(`1970-01-01T${item.timeFrom}`));
    setTimeTo(dayjs(`1970-01-01T${item.timeTo}`));

    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setApprovedById(item.approvedById !== 0 ? true : false);
    setApprovedByName(item.approvedByName || "");
    setNoteFile(item.fileDescription);

    setIsEdit(false);
    setEye(true);
  };

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };

      reader.readAsDataURL(e.target.files[0]);
    };

    input.click();
  }

  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };

  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };

  const res = useSelector((state) => state.AdminRequestR.AddAdminRequest);
  const UP = useSelector((state) => state.AdminRequestR.UpdateAdminRequest);
  const DEL = useSelector((state) => state.AdminRequestR.DeleteAdminRequest);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage ===
              "Great, Administrative Request created Successfully"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("تم اضافة البيانات بنجاح", "success");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "can't create the admin request because the remaining for the request is -1"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("هذا الموظف ليس لديةاجازات كافية", "warn");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "can't create the admin request because you exceeded your limit of holidays"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("تم تخطى الحد المسموح من عدد ايام الاجازات", "warn");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.responseMessage ===
              "Great, admin request updated successfully"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "can't update the admin request because you exceeded your limit of holidays"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("تم تخطى الحد المسموح من عدد ايام الاجازات", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, admin request deleted successfully"
          ) {
            dispatch(
              GetAllAdminRequestAction(buildSearchQuery()),
            );
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {" "}
                {Datee ? new Date(Datee).toLocaleDateString("en-GB") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                value={Datee}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={EmployeesId}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setEmployeesId({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setEmployeesId({
                      name: newValue.inputValue,
                    });
                  } else {
                    setEmployeesId(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  Array.isArray(AllEmplyee && AllEmplyee.data)
                    ? AllEmplyee.data.filter((e) => e.isAccountActive === true)
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموظف
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
            </div>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    طلب إداري
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Request}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      طلب إداري
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => {
                    setRequest(e.target.value);
                  }}>
                  <MenuItem value={"RegularLeave"}>اجازة اعتيادية</MenuItem>
                  <MenuItem value={"EmergencyLeave"}>اجازة عارضة</MenuItem>
                  <MenuItem value={"AnnualLeave"}>اجازة سنوية</MenuItem>
                  <MenuItem value={"SickLeave"}>اجازة مرضي</MenuItem>
                  <MenuItem value={"PermissionToLeave"}> اذن انصراف</MenuItem>
                  <MenuItem value={"PermissionForDelay"}> اذن تأخير</MenuItem>
                  <MenuItem value={"OfficialTaskPermit"}> اذن مأمورية</MenuItem>
                  <MenuItem value={"ComplaintRequest"}>طلب شكوى</MenuItem>
                  <MenuItem value={"InquiryRequest"}> طلب استفسار</MenuItem>
                  <MenuItem value={"BorrowRequest"}> طلب سلفة</MenuItem>
                </Select>
              </FormControl>
            </div>
            {Request === "RegularLeave" ||
            Request === "EmergencyLeave" ||
            Request === "AnnualLeave" ||
            Request === "SickLeave" ? (
              <>
                <div className="inp-container">
                  <div className="dateee">
                    {DateFrom
                      ? new Date(DateFrom).toLocaleDateString("en-GB")
                      : null}
                  </div>
                  <i className="ty fa-solid fa-calendar-days"></i>
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        التاريخ من
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="date"
                    value={DateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                  />
                </div>
                <div className="inp-container">
                  <div className="dateee">
                    {DateTo
                      ? new Date(DateTo).toLocaleDateString("en-GB")
                      : null}
                  </div>
                  <i className="ty fa-solid fa-calendar-days"></i>
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        التاريخ إلى
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="date"
                    value={DateTo}
                    onChange={(e) => {
                      const toDate = new Date(e.target.value);
                      const fromDate = new Date(DateFrom);
                      setDateTo(e.target.value);

                      const diffTime = toDate.getTime() - fromDate.getTime();

                      if (!isNaN(diffTime) && diffTime >= 0) {
                        const diffDays = Math.ceil(
                          diffTime / (1000 * 3600 * 24),
                        );
                        setNumberOfDays(diffDays + 1);
                      } else {
                        setNumberOfDays(0); // Optional: handle invalid or past date
                      }
                    }}
                  />
                </div>
              </>
            ) : Request === "PermissionToLeave" ||
              Request === "PermissionForDelay" ||
              Request === "OfficialTaskPermit" ? (
              <>
                <div className="inp-container clock">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label={
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            التوقيت من
                            <span style={{ color: "red", fontSize: "21px" }}>
                              *
                            </span>
                          </Typography>
                        }
                        defaultValue={""}
                        value={TimeFrom}
                        onChange={(newValue) => setTimeFrom(newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className="inp-container clock">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        label={
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            التوقيت إلى
                            <span style={{ color: "red", fontSize: "21px" }}>
                              *
                            </span>
                          </Typography>
                        }
                        defaultValue={""}
                        value={TimeTo}
                        onChange={(newValue) => {
                          const newTimeTo = newValue;
                          setTimeTo(newTimeTo);

                          const fromDate = new Date(TimeFrom);
                          const toDate = new Date(newTimeTo);

                          if (!isNaN(fromDate) && !isNaN(toDate)) {
                            const diffMilliseconds =
                              toDate.getTime() - fromDate.getTime();

                            if (diffMilliseconds >= 0) {
                              const totalMinutes =
                                diffMilliseconds / (1000 * 60);
                              const hours = Math.floor(totalMinutes / 60);
                              const minutes = Math.round(totalMinutes % 60);

                              // Store the formatted string
                              setNumberOfHours(
                                "hours " + hours + ", minutes  " + minutes,
                              );

                              // Optionally store decimal value too
                              // setDecimalHours(totalMinutes / 60);
                            } else {
                              setNumberOfHours("0 hours, 0 minutes");
                            }
                          } else {
                            setNumberOfHours("Invalid date");
                          }
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </>
            ) : null}
            {Request === "RegularLeave" ||
            Request === "EmergencyLeave" ||
            Request === "AnnualLeave" ||
            Request === "SickLeave" ? (
              <>
                <div className="inp-container">
                  <TextField
                    focused
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        عدد الأيام
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    type="number"
                    value={NumberOfDays}
                    onChange={(e) => setNumberOfDays(e.target.value)}
                    variant="outlined"
                    //   className="ww"
                  />
                </div>

                <div className="inp-container">
                  <TextField
                    label="عدد الأيام المتاحة"
                    variant="outlined"
                    //   className="ww"
                    focused
                    value={NumberOfAvaDays}
                    // onChange={(e) => setNumberOfAvaDays(e.target.value)}
                    type="number"
                  />
                </div>
              </>
            ) : Request === "PermissionToLeave" ||
              Request === "PermissionForDelay" ||
              Request === "OfficialTaskPermit" ? (
              <>
                <div className="inp-container">
                  <TextField
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        عدد الساعات
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    type="text"
                    value={NumberOfHours}
                    onChange={(e) => setNumberOfHours(e.target.value)}
                    //   className="ww"
                  />
                </div>
                {/* <div className="inp-container">
                  <TextField
                    label="عدد الساعات المتاحة"
                    variant="outlined"
                    //   className="ww"
                  />
                </div> */}
              </>
            ) : null}
            {Request === "ComplaintRequest" || Request === "InquiryRequest" ? (
              <>
                <div className="inp-container">
                  <TextField
                    label={
                      Request === "ComplaintRequest"
                        ? "عنوان الشكوى"
                        : "عنوان الاستفسار"
                    }
                    inputProps={{ maxLength: 120 }}
                    type="text"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNoteFile(e.target.value)}
                    value={NoteFile}
                  />
                  <i
                    onClick={importData}
                    className="ty fa-solid fa-paperclip"
                    style={{ color: "#1866ec" }}></i>
                </div>
                {selectedFile && (
                  <div className="fi">
                    <a
                      href={FileeBase64 ? FileeBase64 : selectedFile}
                      target="blank"
                      download={selectedFile.name}>
                      {selectedFile.name ? (
                        selectedFile.name
                      ) : (
                        <i
                          className=" fa-solid fa-paperclip"
                          style={{ color: "#1866ec" }}></i>
                      )}
                    </a>
                    <div style={{ display: "block" }}>Attach File</div>
                    <button
                      style={{ background: "transparent" }}
                      className="buttonadd d">
                      <i
                        onClick={(idx) => deleteFile(idx)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "red" }}></i>
                    </button>
                  </div>
                )}
                <div className="inp-container w-290">
                  <TextField
                    label="إعتماد بواسطة "
                    variant="outlined"
                    //   className="ww"
                    value={userData.name}
                    focused
                    disabled
                  />
                  <div className="input-check">
                    <input
                      className="input-check"
                      type="checkbox"
                      checked={ApprovedById}
                      onChange={(e) => setApprovedById(e.target.checked)}
                    />
                  </div>
                </div>
                <div className="inp-container">
                  <TextField
                    label="ملاحظات"
                    variant="outlined"
                    onChange={(e) => setNote(e.target.value)}
                    value={Note}
                    inputProps={{ maxLength: 120 }}
                  />
                </div>
              </>
            ) : (
              <>
                {Request === "BorrowRequest" ? (
                  <div className="inp-container">
                    <TextField
                      label="القيمة"
                      value={BorrowValue}
                      onChange={(e) => setBorrowValue(e.target.value)}
                      type="number"
                      inputProps={{ maxLength: 120 }}
                      variant="outlined"
                      //   className="ww"
                    />
                  </div>
                ) : null}
                <div className="inp-container w-290">
                  <TextField
                    label="إعتماد بواسطة "
                    variant="outlined"
                    //   className="ww"
                    value={userData.name}
                    focused
                    disabled
                  />
                  <div className="input-check">
                    <input
                      className="input-check"
                      type="checkbox"
                      checked={ApprovedById}
                      onChange={(e) => setApprovedById(e.target.checked)}
                    />
                  </div>
                </div>

                <div className="inp-container">
                  <TextField
                    label="ملاحظات"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNote(e.target.value)}
                    value={Note}
                    inputProps={{ maxLength: 120 }}
                  />
                </div>
                <div className="inp-container">
                  <TextField
                    label="أرشيف المستندات"
                    inputProps={{ maxLength: 120 }}
                    type="text"
                    variant="outlined"
                    //   className="ww"
                    onChange={(e) => setNoteFile(e.target.value)}
                    value={NoteFile}
                  />
                  <i
                    onClick={importData}
                    className="ty fa-solid fa-paperclip"
                    style={{ color: "#1866ec" }}></i>
                </div>
                <div className="inp-container">
                  {selectedFile && (
                    <div className="fi">
                      <a
                        href={FileeBase64 ? FileeBase64 : selectedFile}
                        target="blank"
                        download={selectedFile.name}>
                        {selectedFile.name ? (
                          selectedFile.name
                        ) : (
                          <i
                            className=" fa-solid fa-paperclip"
                            style={{ color: "#1866ec" }}></i>
                        )}
                      </a>
                      <div style={{ display: "block" }}>Attach File</div>
                      <button
                        style={{ background: "transparent" }}
                        className="buttonadd d">
                        <i
                          onClick={(idx) => deleteFile(idx)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                value={Search}
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSearch}></i>
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" type="button" onClick={handleSearch}>
            بحث
          </button>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع الطلب <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                من<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                إلى<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ادخال / مراجعة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {filteredRequests.length > 0
              ? filteredRequests.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>
                        {item.request === "RegularLeave"
                          ? "اجازة اعتيادية"
                          : item.request === "EmergencyLeave"
                            ? "اجازة عارضة"
                            : item.request === "AnnualLeave"
                              ? "اجازة سنوية"
                              : item.request === "SickLeave"
                                ? "اجازة مرضي"
                                : item.request === "PermissionToLeave"
                                  ? "اذن انصراف"
                                  : item.request === "PermissionForDelay"
                                    ? "اذن تأخير"
                                    : item.request === "OfficialTaskPermit"
                                      ? "اذن مأمورية"
                                      : item.request === "ComplaintRequest"
                                        ? "طلب شكوى"
                                        : item.request === "InquiryRequest"
                                          ? "طلب استفسار"
                                          : item.request === "BorrowRequest"
                                            ? "طلب سلفة"
                                            : ""}
                      </td>
                      <td>
                        {item.timeFrom !== null
                          ? item.timeFrom
                          : item.dateFrom !== null
                            ? new Date(item.dateFrom).toLocaleDateString(
                                "en-GB",
                              )
                            : ""}
                      </td>
                      <td>
                        {item.timeTo !== null
                          ? item.timeTo
                          : item.dateTo !== null
                            ? new Date(item.dateTo).toLocaleDateString("en-GB")
                            : ""}
                      </td>
                      <td>
                        {item.numberOfDays !== null
                          ? item.numberOfDays + " أيام"
                          : item.numberOfHours !== null
                            ? item.numberOfHours
                            : ""}
                      </td>
                      {item.approvedById === 0 || item.approvedById === null ? (
                        <td>تحت المراجعة </td>
                      ) : (
                        <td>تمت المراجعة بواسطة {item.approvedByName}</td>
                      )}

                      <td>{item.note}</td>
                      <td>
                        {item.fileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.fileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.fileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        {/* <TableContent
          tablecontent={[
            {
              name: "التاريخ",
              icon: <i className="fa-solid fa-calendar-days"></i>,
            },
            { name: "اسم الموظف", icon: <i className="fa-solid fa-user"></i> },

            {
              name: "نوع الطلب",
              icon: <i className="fa-solid fa-calendar-days"></i>,
            },

            {
              name: " من ",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: " إلى",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            {
              name: "عدد ",
              icon: <i className="fa-solid fa-layer-group"></i>,
            },
            // {
            //   name: "نوع الدعوى",
            //   icon: <i className="fa-solid fa-school"></i>,
            // },
            // {
            //   name: "رقم التسوية",
            //   icon:<i className="fa-solid fa-hashtag"></i>,
            // },
            // {
            //   name: "المحكمة",
            //   icon:   <i className="fa-solid fa-scale-balanced"></i>,
            // },
            {
              name: "",
            },
            {
              name: "",
            },
            {
              name: "",
            },
          ]}
          data={[9, 10, 11]}
        /> */}
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                      <Modal.Title> </Modal.Title>
                    </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`,
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <FormPrintView
        ref={printRef}
        title="بيانات الطلب"
        fields={buildAdminRequestPrintFields({
          EmployeesId,
          Datee,
          Request,
          DateFrom,
          DateTo,
          TimeFrom,
          TimeTo,
          NumberOfDays,
          NumberOfHours,
          BorrowValue,
          NoteFile,
          Note,
          approvedById: ApprovedById ? 1 : 0,
          approvedByName,
        })}
      />
    </>
  );
};
export default Enter;
